<template>
  <div class="model_container">
    <!---关键词--->
    <div class="knowLegeDataContainer">
      <el-row class="keyword_container">
        <template v-for="(item, index) in knowledgeWords">
          <template v-if="index < (knowledgeWords.length - 1)">
            <div class="keyword_unit" :key="index">
              <el-checkbox-group v-model="keywordCheckedList">
                <el-checkbox :label="item.word">
                  <div></div>
                </el-checkbox>
                <el-link :underline="false" @click="openBaike(item.word)">{{ item.word }}</el-link>
              </el-checkbox-group>
            </div>
          </template>
        </template>
        <template v-for="(item, index) in knowledgeWords">
          <template v-if="index === (knowledgeWords.length - 1)">
            <div :key="index">
              <div class="keyword_unit">
                <el-checkbox-group v-model="keywordCheckedList">
                  <el-checkbox :label="item.word">
                    <div></div>
                  </el-checkbox>
                  <el-link :underline="false" @click="openBaike(item.word)">{{ item.word }}</el-link>
                </el-checkbox-group>
              </div>
              <div class="keyword_unit" style="background: white;">
                <el-popover placement="top" width="100px" trigger="hover">
                  <el-link @click="searchKeywords('https://s.weibo.com/weibo?Refer=user_weibo&q=')"
                    :underline="false"><img src="../../assets/imgs/sina.png" width="25px" /></el-link>&nbsp;
                  <el-link
                    @click="searchKeywords('https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=0&rsv_idx=1&tn=50000042_hao_pg&wd=')"
                    :underline="false"><img src="../../assets/imgs/baidu.png" width="25px" /></el-link>&nbsp;
                  <el-link @click="searchKeywords('https://www.zhihu.com/search?type=content&q=')" :underline="false"><img
                      src="../../assets/imgs/zhihu.png" width="25px" /></el-link>
                  <el-link @click="searchKeywords('https://www.douban.com/search?q=')" :underline="false"><img
                      src="../../assets/imgs/douban.png" width="25px" /></el-link>&nbsp;
                  <el-button class="searchBtn" slot="reference"><i class="iconfont">&#xe61b;</i></el-button>
                </el-popover>
              </div>
            </div>
          </template>
        </template>

        <div style="clear: both;border-bottom: 1px solid #ccc;"></div>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-link :underline="false" @click="openKnowLegeDialog">
            <h3 style="color:#2e8eff">
              {{ knowLegeKeyWord }}
            </h3>
          </el-link>
          <span style="color:#999">（点击进入拖拽组稿）</span>
        </el-col>
        <el-col :span="8" style="text-align: right;">
          <el-form :inline="true" action="javascript:void(0)">
            <el-form-item>
              <el-input placeholder="搜索" v-model="tempKnowlegeSearchKey" clearable size="mini"
                class="knowlegeSearchContainer">
              </el-input>
            </el-form-item>
            <el-form-item style="display:none">
              <el-button type="primary" native-type="submit" @click="searchKnowlege">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <template v-if="!knowLegeSearching">
        <div v-if="!knowLegeEmpty">
          <p v-for="(item, index) in knowLegeData" :key="index">
            {{ item.name }}：{{ item.value }}
          </p>

        </div>
        <div class="empty" v-else>
        </div>
      </template>
      <div class="loading" v-else>
      </div>

    </div>

    <!--知识库扩展框--->
    <el-dialog :append-to-body='true' class="newsDetailDialogContainer" width="93%" :show-close=false
      :visible.sync="KnowLegeDialogVisible">
      <el-row class="newsDetailDialogTitle">
        <el-col :span="12">
          <h5 style="margin:0px">素材详情
            <el-link :underline="false" @click="backHistory" :disabled='historyIndex == historyArray.length - 1'> <i
                class="iconfont back_pre_icon">&#xe62d;</i></el-link>
            <el-link :underline="false" @click="fontHistory" :disabled='historyIndex == 0'> <i
                class="iconfont back_pre_icon">&#xe62c;</i></el-link>
          </h5>
        </el-col>
        <el-col :span="12">
          <el-link :underline="false" class="f_r" @click="KnowLegeDialogVisible = false"><i
              class="iconfont">&#xe69f;</i></el-link>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11" class="newsDetail">
          <el-row class="sourceNewsTitle">
            <el-link :underline="false" target="_blank"> {{ knowLegeKeyWord }}</el-link>
          </el-row>
          <el-row class="newsSourceInfo">
            来源：弈写
          </el-row>
          <el-row>
            <draggable v-model="knowLegHtmlData" class="dragContainer1" tag="div" @end="dragEnd"
              :group="{ name: 'comp', pull: 'clone', put: false }" :options="{ draggable: '.item_left', sort: false }">
              <div v-for="(item, index) in knowLegHtmlData" :key="index" class="item_left">
                <p v-html="item" class="dragAbleLeft" style="cursor:pointer" contenteditable="false"></p>
              </div>
            </draggable>
          </el-row>
        </el-col>
        <el-col :span="12" class="newsDetail" :offset="1">
          <div class="articleDragContainer">
            <div class="aritlceDragTitle">
              初稿：&nbsp;{{ articleInfo.title }}
            </div>
            <draggable v-model="articleContentArray" tag="div" @end="dragEnd" class="dragContainer2"
              :group="{ name: 'comp', put: true }" :options="{ draggable: '.item_right', sort: true }">
              <div v-for="(item, index) in articleContentArray" :key="index" class="item_right">
                <p v-html="item" contenteditable="true" @input="handleEditSection(index, $event.target.innerHTML)"
                  @blur="handBlueSection" class="deleteAble dragAbleRight"></p>
                <span class="articleDeleteBtnContainer">
                  <el-link :underline="false" @click="removeItemFromArticle(index)"><i class="iconfont">&#xe75a;</i>
                  </el-link>
                </span>
              </div>
            </draggable>
          </div>
          <div style="margin-top:15px;">
            <el-input placeholder="请输入内容" v-model="appendContent">
              <el-button slot="append" @click="appndContentToArray" :disabled="appendContent === ''">插入内容</el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  props: ['articleId', 'articleInfo', 'searchKey'],
  components: {
    draggable
  },
  name: 'bindMobile',
  data: function () {
    return {
      historyIndex: 0,
      historyArray: [],
      // 关键词
      KnowLegeDialogVisible: false,
      knowLegeSearching: true,
      knowLegeEmpty: false,
      tempKnowlegeSearchKey: '',
      knowLegeData: [],
      knowLegHtmlData: [],
      knowLegeCache: {},
      knowLegeKeyWord: '',
      knowledgeWords: [],
      appendContent: '',
      articleContentArray: []
    }
  },
  metaInfo () {
    return {
      title: '弈写AI辅助写作'
    }
  },
  methods: {

    // 搜索第三方
    searchKeywords (url) {
      if (this.keywordCheckedList && this.keywordCheckedList.length > 0) {
        window.open(url + this.keywordCheckedList.join(' '), '_blank')
      } else {
        this.$message.error('请至少选择一个关键词')
      }
    },
    updateArticle () {
      this.updateContentArray()
    },
    removeItemFromArticle (index) {
      this.articleContentArray.splice(index, 1)
      this.pushToHistoryArray()
    },
    async checkRight () {
      this.updateContentArray()
      if (!this.articleId) {
        this.hasRight = true
        return
      }
      let _this = this
      this.hasRight = false
      await this.axios.post('/webApi/v3/article/news-right-info?' + Math.random(), { 'autoDocId': this.articleId }).then(resp => {
        if (resp.data.myNewsIsBuy === 'YES' && resp.data.myNewsHaveVipTime > 0) { // 已经购买 未过期
          _this.hasRight = true
        } else if (resp.data.userVipLevel === 'GOLD') { // 黄金会员
          _this.hasRight = true
        } else if (resp.data.freeUseCount > 0) { // 有剩余次数
          this.$confirm('您当前为普通会员，当前剩余体验次数' + resp.data.freeUseCount + '次,确认使用？', '温馨提示', {
            confirmButtonText: '使用',
            cancelButtonText: '稍后再说',
            type: 'warning'
          }).then(() => {
            _this.userOneceRight()
          });
        } else { // 只能购买会员了
          this.$confirm('您需要升级为黄金VIP，才可使用此高级功能！', '温馨提示', {
            confirmButtonText: '升级VIP',
            cancelButtonText: '稍后再说',
            type: 'warning'
          }).then(() => {
            let routeUrl = this.$router.resolve({ path: '/userInfo' })
            window.open(routeUrl.href, '_blank');
          })
        }
      })
    },
    pushToHistoryArray () {
      let tempArray = []
      if (sessionStorage.getItem('historyArray')) {
        tempArray = JSON.parse(sessionStorage.getItem('historyArray'))
      }
      if (JSON.stringify(tempArray[0]) === JSON.stringify(this.articleContentArray)) {
        return
      }
      if (this.tempHistoryLock) {
        tempArray.splice(0, this.historyIndex)
        tempArray.unshift(this.articleContentArray)
        sessionStorage.setItem('historyArray', JSON.stringify(tempArray))
        this.historyIndex = 0
        this.historyArray = tempArray
        this.updateArticleContent()
      } else {
        this.tempHistoryLock = true
      }
    },
    updateArticleContent () {
      let temp = ''
      this.articleContentArray.forEach(a => {
        temp = temp + '<p>' + a + '</a>'
      })
      this.$emit('modifyArticleContent', temp)
      this.$forceUpdate()
    },
    appndContentToArray () {
      this.articleContentArray.push(this.appendContent)
      this.updateArticleContent()
    },
    dragEnd (val) {
      this.updateArticleContent()
    },
    backHistory () {
      this.$emit('backHistory')
    },
    fontHistory () {
      this.$emit('fontHistory')
    },
    handleEditSection (index, html) {
      this.articleContentArray[index] = html
    },
    handBlueSection (index, html) {
      this.updateArticleContent()
    },
    updateContentArray () {
      this.articleContentArray = []
      let parser = new DOMParser()
      let htmlDoc = parser.parseFromString(this.articleInfo.autoDoc2, 'text/html')
      for (var i = 0; i < htmlDoc.getElementsByTagName('body')[0].childElementCount; i++) {
        let e = htmlDoc.getElementsByTagName('body')[0].children[i]
        if (e.innerHTML !== '' && e.innerHTML !== '&nbsp;') {
          if (e.tagName !== 'P') {
            this.articleContentArray.push(e.outerHTML)
          } else {
            this.articleContentArray.push(e.innerHTML)
          }
        }
      }
      this.$forceUpdate()
    },
    // 打开 知识库 拖拽框
    openKnowLegeDialog () {
      this.checkRight().then(() => {
        if (this.hasRight) {
          sessionStorage.removeItem('historyArray')
          this.historyIndex = 0
          this.pushToHistoryArray()
          this.KnowLegeDialogVisible = true
          this.parseKnowlege()
        }
      })
    },

    openBaike (key) {
      if (!key) {
        this.knowLegeSearching = false
        this.knowLegeEmpty = true
        return
      }
      this.knowLegeData = []
      this.knowLegeKeyWord = key
      for (var i = 0; i < this.knowledgeWords.length; i++) {
        let temp = this.knowledgeWords[i]
        if (temp.word === key) {
          this.knowLegeData = temp.knowledges
          this.knowLegeSearching = false
          this.knowLegeEmpty = false
          return
        }
      }

      this.knowLegeKeyWord = key
      let tempKey = 'KL_' + key
      let data = sessionStorage.getItem(tempKey);
      if (data && data !== 'undefined') {
        this.knowLegeData = JSON.parse(data)
        this.parseKnowlege()
      } else {
        let _this = this
        this.knowLegeSearching = true
        this.axios.post('/webApi/v3/assist/knowledgeGraphSearch', { 'keyword': key }).then(resp => {
          _this.knowLegeData = resp.data
          _this.parseKnowlege()
          _this.knowLegeSearching = false
          _this.knowLegeEmpty = (_this.knowLegeData && _this.knowLegeData.length === 0)
          sessionStorage.setItem(tempKey, JSON.stringify(resp.data))
        })
      }
    },
    parseKnowlege () {
      let _this = this
      _this.knowLegHtmlData = []
      _this.knowLegeData.forEach(f => {
        _this.knowLegHtmlData.push(f.name + ':' + f.value)
      })
    },
    searchKnowlege () {
      this.knowLegeKeyWord = this.tempKnowlegeSearchKey
      this.openBaike(this.knowLegeKeyWord)
    },
    // 关键词相关
    getKnowledgeWords () {
      let _this = this
      this.axios.get('/webApi/v3/assist/knowledgeWords?articleId=' + _this.articleId).then(resp => {
        _this.knowledgeWords = resp.data
        _this.keywordCheckedList = []
        if (resp.data && resp.data.length > 0) {
          _this.knowLegeKeyWord = resp.data[0]
          _this.keywordCheckedList.push(resp.data[0].word)
        }
        if (resp.data && resp.data.length > 1) {
          _this.keywordCheckedList.push(resp.data[1].word)
        }
        if (resp.data[0]) {
          _this.openBaike(resp.data[0].word)
        } else {
          _this.openBaike(null)
        }
      })
    }
  },
  computed: {

  },
  watch: {
    searchKey: function () {
      console.log(this.searchKey)
      if (this.searchKey) {
        this.tempKnowlegeSearchKey = this.searchKey
        this.openBaike(this.searchKey)
      }
    }
  },
  mounted () {
    if (this.articleId) {
      this.getKnowledgeWords()
    }
  }
}

</script>
<style lang="less">
.knowlegeTab {
  .loading {
    background-image: url("../../assets/imgs/loading.png");
    width: 150px;
    height: 150px;
    background-size: contain;
    margin: auto;
    margin-top: 50px;
    text-align: center;
  }

  .loading::after {
    content: "加载中...";
    color: #989FB0;
    position: relative;
    top: 100%;
  }

  .empty {
    background-image: url("../../assets/imgs/empty.png");
    width: 150px;
    height: 150px;
    background-size: contain;
    margin: auto;
    margin-top: 50px;
    text-align: center;
  }

  .empty::after {
    content: "无数据...";
    color: #989FB0;
    position: relative;
    top: 100%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/article/knowlegeTab.vue